module.exports = [
  'RESTService',
  (RESTService) ->
    RESTService.setFullResponse(true).service('admin/statement_records')
]
